module.exports = __webpack_public_path__ + "static/img/logo-mb.c080ba5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-mb.png
// module id = PreA
// module chunks = 1